<!--suppress ALL -->
<script lang="ts">
import {penerimaDana} from '../../../util/PluralVariabels';
  import {Component, Vue, Prop} from 'annotation';
  import {cloneArray} from "../../../util/Underscore";

  import GField from '../common/field/GField.vue';
  import GSelect from '../common/select/GSelect.vue';

  @Component
  export default class PenerimaSelect extends Vue {

    @Prop({default: penerimaDana[0].value, type: String})
    public penerima: string;

    @Prop({default: false, type: Boolean})
    public skipLabel: boolean;

    @Prop({default: true, type: Boolean})
    public isFullwidth: boolean;

    @Prop({type: String, default: null})
    public type: any;

    @Prop({type: String, default: null})
    public message: any;

    @Prop({type: Boolean, default: false})
    public disabled: any;

    public onSelectPenerima(param: string) {
      this.$emit('update:penerima', param || penerimaDana[0].value);
      this.$emit('selected', param);
    }

    public render(createElement: Function) {
      const {$t, penerima, isFullwidth, message, type} = this;

      const mainAttr: any = {
        props: {
          value: penerima,
          isFullwidth, placeholder: `${$t('label.choose')} ${$t('label.penerima')}`
        },
        attrs: {disabled: this.disabled},
        on: {change: this.onSelectPenerima}
      };

      const main: any = createElement(GSelect, mainAttr, cloneArray(penerimaDana).map((item: any) => {
        const option: any = {key: item.value, attrs: {value: item.value}};

        return createElement('option', option, item.label.toUpperCase());
      }));

      if (this.skipLabel) {
        return main;
      }

      return createElement(GField, {props: {label: $t('label.penerima'), message, type}}, [main]);
    }
  }
</script>
